"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomColorPicker = CustomColorPicker;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("./utils");
var _reactColor = require("react-color");
var _styles = require("../Input/Text/styles");
const _excluded = ["selectedColor", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const S = {
  CustomPicker: (0, _styledComponents.default)(_reactColor.ChromePicker)`
        width: 213px !important;
        font-family: inherit !important;
        box-shadow: none !important;

        input > {
            ${_styles.commonInputStyles}
        }

        /* SLIDERS */

        > div:nth-child(1) > div > div > div:nth-child(2) > div {
            width: 16px !important;
            height: 16px !important;
            transform: translate(-8px, -8px) !important;
            box-sizing: border-box;
            border-radius: 50% !important;
        }

        > div:nth-child(2) > div:nth-child(1) > div:nth-child(2) > div:nth-child(2) > div > div:nth-child(2),
        > div:nth-child(2) > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > div > div {
            border-radius: 2px;
        }

        /* HUE Thumb */
        > div:nth-child(2) > div:nth-child(1) > div:nth-child(2) > div:nth-child(2) > div > div:nth-child(3) > div > div,
        /* Opacity Thumb */
        > div:nth-child(2) > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > div > div > div > div
        {
            border-radius: 50% !important;
            outline: 0 !important;
            border: 1px solid var(--grey5) !important;
            background-color: var(--bg-color) !important;
            width: 16px !important;
            height: 16px !important;
            transform: translate(-6px, -3px) !important;
            box-shadow: none !important;
            box-sizing: border-box;
        }

        > div:nth-child(1) {
            border-radius: 0 !important;
        }

        > div:nth-child(1) > div {
            border-radius: 2px;
        }

        /* Preview of the selected color */
        > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) {
            display: none;

        }

        > div:nth-child(2) > div:nth-child(2) > div.flexbox-fix {
            margin-left: 0 !important;
        }
        
        > div:nth-child(2) > div:nth-child(2) > div.flexbox-fix > div {
            padding-right: 7px !important;
            padding-left: 0 !important;
        }

        /* The holder for the arrows for switching RGB/HEX */
        > div:nth-child(2) > div:nth-child(2) > div:nth-child(2) > div {
            margin-right: 0 !important;
            margin-top: 9 !important;
        }

        /* The div with the sliders */
        > div:nth-child(2) {
            padding: 0 !important;
            padding-top: 7px !important;

            /* RGBA / HEX Switcher */
            > div:nth-child(2) {
                padding-top: 7px !important;

                input, label {
                    font-size: 14px !important;
                }

                label {
                    margin-top: 7px !important;
                }
            }
        }
    `
};
function CustomColorPicker(_ref) {
  let {
      selectedColor = _utils.RGBColor.DEFAULT_COLOR,
      onChange
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const handleChange = reactPickerColorObject => {
    onChange(_utils.RGBColor.fromObject(reactPickerColorObject.rgb));
  };
  return /*#__PURE__*/_react.default.createElement(S.CustomPicker, _extends({
    color: selectedColor,
    onChange: handleChange
  }, rest));
}
CustomColorPicker.propTypes = _objectSpread({
  customColors: _propTypes.default.arrayOf(_propTypes.default.instanceOf(_utils.RGBColor)),
  selectedColor: _propTypes.default.instanceOf(_utils.RGBColor),
  onChange: _propTypes.default.func
}, _reactColor.ChromePicker.propTypes);